/**
 * LOP - Script para prevenir salto de línea en "Precio sin impuestos nacionales"
 * Detecta cuando el texto va a hacer salto de línea y cambia automáticamente
 * a "Precio sin imp país". Si aún así hay salto, reduce el font-size.
 * Este script maneja productos cargados dinámicamente y cambios de tamaño.
 */

(function() {
  'use strict';

  // Configuración
  const CONFIG = {
    desktopBreakpoint: 769, // Solo aplicar en desktop (mayor a 768px)
    fontSizeReduction: 1, // Reducir 1px si aún hay salto
    minFontSize: 11 // Tamaño mínimo de fuente
  };

  /**
   * Obtiene el ancho del texto renderizado
   */
  function getTextWidth(element, text) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const styles = window.getComputedStyle(element);
    
    context.font = `${styles.fontWeight} ${styles.fontSize} ${styles.fontFamily}`;
    return context.measureText(text).width;
  }

  /**
   * Verifica si el texto cabe en una línea
   */
  function checkTextFits(container, labelElement, valueElement) {
    const containerWidth = container.offsetWidth;
    const gap = parseFloat(window.getComputedStyle(container).gap) || 4;
    
    const labelText = labelElement.textContent.trim();
    const labelWidth = getTextWidth(labelElement, labelText);
    
    const valueText = valueElement.textContent.trim();
    const valueWidth = getTextWidth(valueElement, valueText);
    
    const totalWidth = labelWidth + valueWidth + gap;
    return totalWidth <= containerWidth;
  }

  /**
   * Ajusta el texto y tamaño según sea necesario
   */
  function adjustPriceText(container) {
    // Solo aplicar en desktop
    if (window.innerWidth < CONFIG.desktopBreakpoint) {
      return;
    }

    // Si ya fue procesado por el script inline, no hacer nada
    if (container.classList.contains('lop-price-measured')) {
      return;
    }

    const labelDesktop = container.querySelector('.LOP-price-without-taxes-label-desktop');
    const labelMobile = container.querySelector('.LOP-price-without-taxes-label-mobile');
    const valueElement = container.querySelector('.LOP-price-without-taxes-value');

    if (!labelDesktop || !labelMobile || !valueElement) {
      return;
    }

    // Resetear estado
    labelDesktop.style.display = 'inline';
    labelMobile.style.display = 'none';
    labelDesktop.style.fontSize = '';
    valueElement.style.fontSize = '';

    // Verificar si el texto completo cabe
    if (checkTextFits(container, labelDesktop, valueElement)) {
      labelDesktop.style.display = 'inline';
      labelMobile.style.display = 'none';
    } else {
      // Cambiar a texto corto
      labelDesktop.style.display = 'none';
      labelMobile.style.display = 'inline';

      // Verificar si el texto corto cabe
      if (!checkTextFits(container, labelMobile, valueElement)) {
        // Reducir font-size si aún no cabe
        const currentFontSize = parseFloat(window.getComputedStyle(labelMobile).fontSize);
        const newFontSize = Math.max(
          currentFontSize - CONFIG.fontSizeReduction,
          CONFIG.minFontSize
        );

        labelMobile.style.fontSize = `${newFontSize}px`;
        valueElement.style.fontSize = `${newFontSize}px`;
      }
    }

    // Marcar como procesado
    container.classList.add('lop-price-measured');
  }

  /**
   * Procesa todos los contenedores de precio
   */
  function processAllContainers() {
    const containers = document.querySelectorAll('.product-card .LOP-product-price-without-taxes');
    
    containers.forEach(container => {
      requestAnimationFrame(() => {
        adjustPriceText(container);
      });
    });
  }

  /**
   * Expone función global para ser llamada desde otros scripts
   */
  window.processLOPPriceContainers = function() {
    processAllContainers();
  };

  /**
   * Inicializa el script
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Procesar contenedores existentes que no fueron procesados por el script inline
    // Usar múltiples intentos para asegurar que los primeros productos del carrusel se procesen
    processAllContainers();
    
    // Re-procesar después de un delay para capturar productos que puedan no haberse renderizado completamente
    setTimeout(() => {
      // Remover clase de procesado de contenedores que no tienen ancho (no renderizados)
      document.querySelectorAll('.product-card .LOP-product-price-without-taxes.lop-price-measured').forEach(container => {
        if (container.offsetWidth === 0) {
          container.classList.remove('lop-price-measured');
        }
      });
      processAllContainers();
    }, 300);
    
    // Un último intento después de más tiempo para productos en carruseles
    setTimeout(() => {
      document.querySelectorAll('.product-card .LOP-product-price-without-taxes:not(.lop-price-measured)').forEach(container => {
        if (container.offsetWidth > 0) {
          adjustPriceText(container);
        }
      });
    }, 600);

    // Observar cambios en el DOM (productos cargados dinámicamente)
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('LOP-product-price-without-taxes')) {
                shouldProcess = true;
              } else if (node.querySelector && node.querySelector('.LOP-product-price-without-taxes')) {
                shouldProcess = true;
              }
            }
          });
        }
      });

      if (shouldProcess) {
        clearTimeout(window.LOPPriceAdjustTimeout);
        window.LOPPriceAdjustTimeout = setTimeout(processAllContainers, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Re-procesar cuando cambie el tamaño de ventana
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Remover clase para re-evaluar
        document.querySelectorAll('.product-card .LOP-product-price-without-taxes.lop-price-measured').forEach(el => {
          el.classList.remove('lop-price-measured');
        });
        processAllContainers();
      }, 150);
    });

    // Escuchar evento personalizado para productos cargados dinámicamente
    document.addEventListener('lop-price-needs-adjustment', (event) => {
      if (event.detail && event.detail.container) {
        requestAnimationFrame(() => {
          adjustPriceText(event.detail.container);
        });
      }
    });
  }

  init();
})();

